import { IDocumentLibraryService, ImportDocument } from "../documents"
import { OmniaService } from "../service"
import { IOmniaSession } from "../types"
import { setDates } from "../utils/date"

export class DocumentLibraryService extends OmniaService implements IDocumentLibraryService {

    static $inject = ["OmniaSession", "omniaApiUrl"];

    constructor(protected session: IOmniaSession, private apiUrl: string) {

        super(session, { name: "DocumentLibrary", module: undefined, dependencies: [] })

    }

    getRefreshPromise() {
        return undefined
    }

    readFiles(year: number): ng.IPromise<ImportDocument[]> {

        var url = "/api/import/document/read/" + this.holdingId + "/" + year;

        return this.ohttp.get(url).then(r => {
            var data = r.data;

            if (data) {
                setDates(data, ["UploadDate", "ExifDate"], false);
            }

            return data;

        });


    }

    readFilesByIds(picturesIds: any[]): ng.IPromise<ImportDocument[]> {

        var url = "/api/import/document/read/ids";

        return this.ohttp.post(url, picturesIds).then(r => {
            var data = r.data;

            if (data) {
                setDates(data, ["UploadDate", "ExifDate"], false);
            }

            return data;

        });

    }

    importFile(data: FormData): ng.IPromise<any> {

        const url = "/api/import/document/import/" + this.holdingId + "/" + this.yearId;

        const options = {
            clearContentType: true
        }

        return this.ohttp.post(url, data, options)

    }

    removeFile(documentId: number): ng.IPromise<any> {

        var url = "/api/import/document/delete/" + documentId;

        return this.ohttp.post(url);

    }

    getImgPath(document: ImportDocument, variant?: undefined | "thumbnail" | "original"): string {

        const thumbnail = variant == "thumbnail"
        const original = variant == "original"

        return [
            this.apiUrl,
            "/api/img/",
            document.HoldingId,
            "/",
            this.getFileName(document),
            (thumbnail ? "-thumbnail" : ""),
            "/",
            this.getFileExtension(document),
            "?v=1",
            original ? "&original=2" : ""
        ].join("")

    }

    saveFileProperties(importDocument: ImportDocument): ng.IPromise<any> {

        var url = "/api/import/document/edit";

        return this.ohttp.post(url, importDocument);

    }

    private getFileName(document: ImportDocument) {
        var fileNameSplit = document.FilePath.split('/');

        var fileName = fileNameSplit[fileNameSplit.length - 1];
        return fileName.substr(0, fileName.lastIndexOf("."));
    }

    private getFileExtension(document: ImportDocument) {
        var fileNameSplit = document.FilePath.split('/');

        var fileName = fileNameSplit[fileNameSplit.length - 1];
        return fileName.substr(fileName.lastIndexOf(".") + 1);
    }

}
